// extracted by mini-css-extract-plugin
export var gif = "_cs-0";